export const COMMON_TAB_STYLES =
  'font-medium border border-burnt-orang hover:bg-[#ff9146] active:bg-[ff6700]';
export const ACTIVE_TAB_STYLES = 'bg-primary text-white';
export const INACTIVE_TAB_STYLES = 'text-black';
